import { PlatformCredentialField } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialFieldConfig';

export const getPlatformFieldName = (platformField: PlatformCredentialField) =>
  platformField.replace(/([A-Z])/g, '_$1').toLowerCase();
